import * as Sentry from "@sentry/react";
import { matchPath } from "react-router-dom";

type RouteTags = {
  route: string;
  report_id: string | undefined;
  report_tab: string | undefined;
  application_id: string | undefined;
};

/**
 * Tags describing the in-app route. The router lives in the URL hash, which
 * Sentry's own `url` tag drops, so without these every event reads as "/".
 * `route` keeps ids out so it groups across reports.
 */
export const routeTagsForPath = (pathname: string): RouteTags => {
  const report = matchPath("/dashboard/report/:reportId/:tabPath?/*", pathname);
  if (report) {
    const tab = report.params.tabPath;
    return {
      route: `/dashboard/report/:reportId${tab ? "/" + tab : ""}`,
      report_id: report.params.reportId,
      report_tab: tab,
      application_id: undefined,
    };
  }
  const history = matchPath(
    "/dashboard/submission-history/detail/:reportId",
    pathname
  );
  if (history) {
    return {
      route: history.pattern.path,
      report_id: history.params.reportId,
      report_tab: undefined,
      application_id: undefined,
    };
  }
  const policy = matchPath("/dashboard/policy/:applicationId", pathname);
  if (policy) {
    return {
      route: policy.pattern.path,
      report_id: undefined,
      report_tab: undefined,
      application_id: policy.params.applicationId,
    };
  }
  return {
    route: pathname,
    report_id: undefined,
    report_tab: undefined,
    application_id: undefined,
  };
};

/** Replaces the route tags on every subsequent Sentry event. */
export const updateSentryRouteTags = (pathname: string) => {
  // Undefined values clear the previous route's tags.
  Sentry.setTags(routeTagsForPath(pathname));
};
